// src/pages/Accounting/Receipts/components/HeroDropZone.tsx

import React, { useRef, useState } from "react";
import { UploadCloud } from "lucide-react";
import { PALETTE } from "../constants";

interface HeroDropZoneProps {
  onFilesDropped: (files: File[]) => void;
}

export function HeroDropZone({ onFilesDropped }: HeroDropZoneProps) {
  const inputRef = useRef<HTMLInputElement>(null);
  const [isDragging, setIsDragging] = useState(false);

  const handleBrowse = () => {
    inputRef.current?.click();
  };

  const handleFileSelect = (e: React.ChangeEvent<HTMLInputElement>) => {
    const files = Array.from(e.target.files ?? []);
    if (files.length > 0) onFilesDropped(files);
  };

  const handleDragOver = (e: React.DragEvent) => {
    e.preventDefault();
    setIsDragging(true);
  };

  const handleDragLeave = () => setIsDragging(false);

  const handleDrop = (e: React.DragEvent) => {
    e.preventDefault();
    setIsDragging(false);
    const files = Array.from(e.dataTransfer.files);
    if (files.length > 0) onFilesDropped(files);
  };

  return (
    <div
      onDragOver={handleDragOver}
      onDragLeave={handleDragLeave}
      onDrop={handleDrop}
      onClick={handleBrowse}
      style={{
        border: `2px dashed ${isDragging ? PALETTE.vela : PALETTE.line}`,
        borderRadius: 14,
        padding: "44px 32px",
        textAlign: "center",
        background: isDragging ? PALETTE.velaFade : "#FDFDFD",
        maxWidth: 720,
        marginBottom: 10,
        cursor: "pointer",
        transition: "border-color 0.15s, background 0.15s",
      }}
    >
      <div
        style={{
          width: 48,
          height: 48,
          borderRadius: 12,
          background: PALETTE.ink,
          color: "#fff",
          display: "inline-flex",
          alignItems: "center",
          justifyContent: "center",
          marginBottom: 14,
        }}
      >
        <UploadCloud size={22} strokeWidth={2} />
      </div>
      <h3
        style={{
          fontSize: 17,
          fontWeight: 800,
          color: PALETTE.ink,
          margin: "0 0 6px",
          letterSpacing: "-0.015em",
        }}
      >
        Drop a receipt here
      </h3>
      <p
        style={{
          fontSize: 12.5,
          color: PALETTE.ink3,
          margin: "0 0 18px",
          fontWeight: 500,
        }}
      >
        Any PDF, image, or scan. Vela reads it in a few seconds.
      </p>
      <button
        type="button"
        onClick={(e) => {
          e.stopPropagation();
          handleBrowse();
        }}
        style={{
          height: 36,
          padding: "0 20px",
          borderRadius: 9,
          background: PALETTE.ink,
          color: "#fff",
          border: "none",
          cursor: "pointer",
          fontSize: 13,
          fontWeight: 700,
          fontFamily: "inherit",
        }}
      >
        Browse files
      </button>
      <div
        style={{
          fontSize: 11,
          color: PALETTE.ink4,
          marginTop: 12,
          fontWeight: 500,
        }}
      >
        Or drag files anywhere on this page.
      </div>
      <input
        ref={inputRef}
        type="file"
        multiple
        accept=".pdf,.png,.jpg,.jpeg,.heic,image/*,application/pdf"
        onChange={handleFileSelect}
        style={{ display: "none" }}
      />
    </div>
  );
}
